import { createActionGroup, props } from '@ngrx/store';
import { MosCommand } from '@src/suite/common/store/mos/models/mos.models';

export const MosActions = createActionGroup({
    source: 'MosCommand',
    events: {
        'Mos Server command send': props<MosCommand>(),
        'Mos Client command send': props<MosCommand>(),
        'Mos Ojb clicked': props<{ mosElemntId: string; storyId: string }>(),
    },
});
